import React, { useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';
import { AuthLayout } from '../components/Layout/AuthLayout';
import { Input } from '../components/common/Input';
import { Button } from '../components/common/Button';
import './Auth.css';

const ForgotPassword = () => {
  usePageTitle('Recuperar senha');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    try {
      setStatus('loading');
      await authApi.forgotPassword(email);
      setStatus('success');
    } catch (err: any) {
      setStatus('error');
      setErrorMessage(err.message || 'Ocorreu um erro. Tente novamente.');
    }
  };

  return (
    <AuthLayout currentStep={1}>
      <div className="auth-page">
        <div className="auth-header">
          <h2 className="auth-title">Recuperar Senha</h2>
          <p className="auth-subtitle">
            Digite seu e-mail para receber as instruções de recuperação.
          </p>
        </div>

        {status === 'success' ? (
          <div style={{ textAlign: 'center', margin: 'var(--space-6) 0' }}>
            <div style={{
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.2)',
              color: '#10b981',
              padding: 'var(--space-4)',
              borderRadius: 'var(--radius-md)',
              marginBottom: 'var(--space-4)',
            }}>
              E-mail Enviado com Sucesso!
            </div>
            <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)', marginBottom: 'var(--space-6)' }}>
              Se o e-mail existir em nossa base, você receberá um link para criar uma nova senha em instantes.
            </p>
            <Link to="/login">
              <Button type="button" variant="secondary" fullWidth>
                Voltar para o Login
              </Button>
            </Link>
          </div>
        ) : (
          <>
            {status === 'error' && (
              <div style={{
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                color: '#f87171',
                padding: 'var(--space-3)',
                borderRadius: 'var(--radius-md)',
                marginBottom: 'var(--space-4)',
                fontSize: 'var(--text-sm)',
                textAlign: 'center'
              }}>
                {errorMessage}
              </div>
            )}

            <form className="auth-form" onSubmit={handleSubmit}>
              <Input 
                label="E-mail Corporativo" 
                name="email" 
                type="email" 
                placeholder="voce@escritorio.com.br" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required 
                disabled={status === 'loading'}
              />

              <Button type="submit" variant="secondary" fullWidth disabled={status === 'loading'}>
                {status === 'loading' ? 'Enviando...' : 'Enviar Link de Recuperação'}
              </Button>
            </form>

            <div className="auth-footer" style={{ marginTop: 'var(--space-6)' }}>
              Lembrou sua senha? <Link to="/login">Volte ao login</Link>
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
